<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M18 10a2 2 0 00-2 2v24a2 2 0 004 0V12a2 2 0 00-2-2zM30 10a2 2 0 00-2 2v24a2 2 0 004 0V12a2 2 0 00-2-2z"/></svg>